// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"8":"1890a5b4","138":"e5629ca2","256":"275124ea","432":"570ec3ae","494":"febb733d","521":"697496ce","700":"a2f7f411","830":"73c3ea88","894":"ec500282","931":"6103a931"}[chunkId] + ".chunk.js";
};